import { Joi, objectSchemaOf } from '../helpers';

export type PresenceEntryType = 'check-in' | 'check-out' | 'presence';

export const presenceEntryTypeSchema = Joi.string().valid(
  'check-in',
  'check-out',
  'presence'
);

export type PresenceSource = 'console' | 'hil' | 'server';

export const presenceSourceSchema = Joi.string().valid(
  'server',
  'hil',
  'console'
);

export interface IPresenceEntry {
  uid: string;
  type: PresenceEntryType;
  source: PresenceSource;
  timestamp: number;
  sessionId: string;
  activationTimestamp: number;
}

export const presenceEntrySchema = objectSchemaOf<IPresenceEntry>({
  uid: Joi.string().required(),
  type: presenceEntryTypeSchema.required(),
  source: presenceSourceSchema.required(),
  timestamp: Joi.number().required(),
  sessionId: Joi.string().required(),
  activationTimestamp: Joi.number().required(),
});
